import { Component, EventEmitter, Input, Injector, Output } from '@angular/core';
import { ResourceService } from '../../../shared/services/resource.service';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

@Component({
    moduleId: module.id,
    selector: 'message-dialog',
    templateUrl: 'message-dialog.component.html'
})
export class MessageDialog extends DiagnosedItem {

    @Input() showConfirmBtn: boolean = true;
    @Input() showDismissBtn: boolean = true;

    @Input() confirmBtnText: string;
    @Input() dismissBtnText: string;

    @Input() message: string;
    divMessage: string;

    @Output() confirmClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() dismissClicked: EventEmitter<any> = new EventEmitter<any>();

    public hideDialog: boolean = true;

    constructor(private resourceService: ResourceService, protected __inj: Injector) {
        super(__inj);

        this.confirmBtnText = resourceService.Localize("MessageDialog_Ok");
        this.dismissBtnText = resourceService.Localize("MessageDialog_Cancel");
        this.message = resourceService.Localize("MessageDialog_DefaultMessage");
    }

    onConfirmClick() {

        this.hideDialog = true;
        this.confirmClicked.emit(true);
    }

    onDismissClick() {

        this.hideDialog = true;
        this.dismissClicked.emit(true);
    }

    show() {
        this.hideDialog = false;
    }

    display(selector: {
        showConfirmBtn?: boolean,
        showDismissBtn?: boolean,
        emptyPreviousSubscriptions?: boolean,
        message: string
    }) {

        if (typeof selector.showConfirmBtn !== 'boolean') selector.showConfirmBtn = true;
        if (typeof selector.showDismissBtn !== 'boolean') selector.showDismissBtn = true;
        if (typeof selector.emptyPreviousSubscriptions !== 'boolean') selector.emptyPreviousSubscriptions = true;

        this.showConfirmBtn = selector.showConfirmBtn;
        this.showDismissBtn = selector.showDismissBtn;
        if (selector.emptyPreviousSubscriptions) {
            this.emptyPreviousSubscriptions();
        }

        this.message = selector.message;

        this.show();

        return this.confirmClicked;
    }

    public emptyPreviousSubscriptions() {
        this.confirmClicked = new EventEmitter<any>();
        this.dismissClicked = new EventEmitter<any>();
        this.divMessage = undefined;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/messageDialog/message-dialog.component.ts